<template>
    <div class="d-flex align-center">
        <v-text-field
            outlined
            hide-details
            disabled
            :value="displayText"/>
        <v-menu
            offset-y
            nudge-bottom="12"
            nudge-width="520"
            v-model="menu"
            :close-on-content-click="false">
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    class="ml-2 px-2"
                    color="primary"
                    style="min-width: 32px;"
                    v-on="on"
                    v-bind="attrs">
                    <icon
                        value="hero_LocationMarker"/>
                </v-btn>
            </template>

            <v-card>
                <v-card-title class="px-4">
                    <div
                        v-html="proccessMapLabel"/>
                </v-card-title>
                <v-card-text class="px-4">
                    <v-text-field
                        outlined
                        hide-details
                        v-model="googleLink"
                        :placeholder="$t('placeholder.googleMapLink')"/>
                </v-card-text>
                <v-card-actions class="px-4">
                    <v-btn
                        outlined
                        color="primary"
                        @click="openGoogleMap">
                        <icon
                            class="mr-4"
                            value="hero_Map"/>
                        {{ $t('button.map') }}
                    </v-btn>

                    <v-spacer/>

                    <v-btn
                        @click="cancel">
                        {{ $t('button.cancel') }}
                    </v-btn>

                    <v-btn
                        color="primary"
                        @click="confirm">
                        {{ $t('button.save') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-menu>
    </div>
</template>

<script>
export default {
    name: 'GeolocationField',

    props: {
        value: {
            type: Object,
            default: () => null
        },

        required: {
            type: Boolean,
            default: false
        },

        readonly: {
            type: Boolean,
            default: false
        },

        disabled: {
            type: Boolean,
            default: false
        }
    },

    data () {
        return {
            googleLink: '',
            menu: null
        }
    },

    watch: {
        menu (newValue) {
            if (newValue) {
                this.resetGoogleLinkField()
            }
        }
    },

    computed: {
        displayText () {
            return this.value ? `${this.value.latitude}, ${this.value.longitude}` : ''
        },

        proccessMapLabel () {
            const requireSymbol = this.$t('required')
            const label = this.$t('field.geolocationMenuHeader')
            return this.required ? `${label} ${requireSymbol}` : label
        }
    },

    methods: {
        openGoogleMap () {
            window.open('https://www.google.com/maps')
        },

        resetGoogleLinkField () {
            this.googleLink = ''
        },

        getGeolocationFromGoogleLink () {
            const googleMapPrefix = 'google.com/maps'
            let geolocationStringList = []
            if (this.googleLink.includes(googleMapPrefix)) {
                const geolocationPrefix = '@'
                geolocationStringList = this.googleLink.slice(this.googleLink.indexOf(geolocationPrefix) + 1).split(',')
            } else {
                geolocationStringList = this.googleLink.split(',')
            }

            const latitude = parseFloat(geolocationStringList?.[0])
            const longitude = parseFloat(geolocationStringList?.[1])

            if (Number.isNaN(latitude) || Number.isNaN(longitude)) {
                alert(`Cannot parse ${this.googleLink}`)
                return null
            }

            return {
                latitude,
                longitude
            }
        },

        confirm () {
            const geolocation = this.getGeolocationFromGoogleLink()
            if (geolocation) {
                this.$emit('input', geolocation)
                this.menu = false
            }
        },

        cancel () {
            this.menu = false
        }
    }
}
</script>

<style lang="scss" scoped>

</style>
